import { SelectedValueReportingFacet } from '../../../../graphql/schema/types/value-reporting'
import { AggregationConfigs } from '../../../aggregations'

export const facetNameToApplicationFilterNameMap = {
  'agent-language': 'languages',
  'application-importance': 'appImportances',
  'application-tags': 'tags',
  'application-technologies': 'technologies'
}

export const facetNameToVulnsFilterNameMap = {
  'agent-language': 'languages',
  'application-technologies': 'technologies',
  'application-importance': 'applicationImportances',
  'application-tags': 'applicationTags'
}

const formatFacetName = (facetName, facetDisplayName) => {
  // TS-22574 The facet names for application-metadata- prefixed names need
  // consistent formatting so that the metadata category has an initial upper case
  const applicationMetadataPrefix = 'application-metadata-'

  if (facetDisplayName) {
    return encodeURIComponent(applicationMetadataPrefix + facetDisplayName)
  }

  let suffix = facetName.replace(applicationMetadataPrefix, '')
  suffix = suffix.charAt(0).toUpperCase() + suffix.substr(1, suffix.length - 1)

  return encodeURIComponent(applicationMetadataPrefix + suffix)
}

export const convertFacetsToFilters = (
  mapping: {},
  facets: SelectedValueReportingFacet[],
  aggregationConfigs: AggregationConfigs<string>
): string => {
  if (!facets) {
    return ''
  }

  return (
    facets
      .map((it) => ({
        key:
          it.facetName.indexOf('application-metadata-') === 0
            ? formatFacetName(
                it.facetName,
                aggregationConfigs[it.facetName]?.groupDisplayName || null
              )
            : mapping[it.facetName],
        value: it.facetValue
      }))
      // exclude unmapped keys
      .filter((it) => it.key)
      // applications filters works with dup keys
      // for multiple entries on a single key
      // build query string this way
      .reduce((acc, it) => `${acc}&${it.key}=${it.value}`, '')
  )
}
